import { useLandingPageSubdomain } from "@/components/CheckoutCreator/hooks/useLandingPageSubdomain";
import { CopyButton, SecondaryButton, Typography } from "@dev/ee-components";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux";
import { CheckoutsIcon, WindowIcon  } from '@dev/ee-components';
import { CheckoutsPaths, LandingPagePaths, HomePaths, pathsParams } from "@/services/dictionaries/Paths";
import { push } from 'redux-first-history';
import useMobile from "@/services/hooks/useMobile";
import { EmptyState } from "../EmptyState";
import { ButtonsBox, CopyBox, useStyles } from "./styles";

export const SubdomainWidgetContent = () => {
    const { t } = useTranslation();
    const {accountSubdomain, checkoutBaseUrl} = useLandingPageSubdomain();
    const typographyRef = useRef(null);
    const dispatch = useDispatch();
    const classes = useStyles();
    const isMobile = useMobile();
    
    const handleSetSubdomainClick = () => {
        window.location.href = HomePaths.EditLPSubdomain;
    }

    const handleCopyLink = () => {
        const text = typographyRef.current.props.children;
        
        navigator.clipboard.writeText(text)
    }
    const handleCreatePage = () => {
        dispatch(push(LandingPagePaths.LandingPageCreator.replace(`${pathsParams.nameOptional}`, '')))
    }

    const handleCreateCheckout = () => {
        dispatch(push(CheckoutsPaths.CheckoutsCreator))
    }

    const urlWithoutProtocol = checkoutBaseUrl?.replace("https://", "");

    return (
        <div className={classes.contentBox}>
        {!accountSubdomain &&
            <EmptyState 
                title={t('readytoshowcase')} 
                description={t('setupyourcustomsubdomain')}
                button={{
                    text:t('setyoursubdomainnow'), 
                    onClick:handleSetSubdomainClick
                }}
            /> 
        }
        {accountSubdomain && <>
            <Typography className={classes.textRightAlign} variant="body1">
                {t('grabyourcustomlink')}
            </Typography>
            <CopyBox isMobile={isMobile}>
                <Typography className={classes.textContainer} ref={typographyRef} variant="h2">
                    {urlWithoutProtocol}
                </Typography> 
                <div className={classes.copyButton}>
                    <CopyButton text={{copy: t('copylink'), copied: t('copiedlinksubdomain')}} onClick={handleCopyLink} />
                </div>
            </CopyBox>
            <Typography variant="body1">
                 {t('donothesitate')}
            </Typography>
            <ButtonsBox isMobile={isMobile}>
                <SecondaryButton startIcon={<WindowIcon/>} text={t('createpage')} onClick={handleCreatePage}/>
                <SecondaryButton startIcon={<CheckoutsIcon/>} text={t('createcheckout')} onClick={handleCreateCheckout}/>
            </ButtonsBox>
        </>}
    </div>
    )
}
